import { Navigate } from 'react-router-dom'
import type { PropsWithChildren } from 'react'
import { useAuthStore } from '../stores/auth'
import { isTenantAdmin } from './roles'

export default function RequireTenantAdmin({ children }: Readonly<PropsWithChildren>) {
  const user = useAuthStore(s => s.user)

  if (!isTenantAdmin(user?.role)) return <Navigate to="/" replace />
  return <>{children}</>
}
